export const uploadTimelineImage = async (imageFile, storeId, resourceId, uploadImageService) => {
  const formData = new FormData()
  formData.append('image', imageFile)

  const response = await uploadImageService({ storeId, resourceId, formData })

  return { id: response?.data?.id, url: response?.data.url }
}
